import { Injectable, inject } from '@angular/core';
import Config from '../utils/config.service';
import AngularFilterHelperService from '../services/angular-filter-helper.service';

@Injectable({ providedIn: 'root' })
export default class SymptomCheckService {
	private config: Config = inject(Config);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	
	state: any = {
		currentStep: undefined,
	};
	
	getSteps() {
		return [{
			id: 'introduction',
			label: this.angularFilterHelperService.translate('Symptom_Check.Links.Introduction'),
		}, {
			id: 'patient',
			label: this.angularFilterHelperService.translate('Symptom_Check.Links.Patient'),
		}, {
			id: 'factors',
			label: this.angularFilterHelperService.translate('Symptom_Check.Links.Factors'),
		}, {
			id: 'symptoms',
			label: this.angularFilterHelperService.translate('Symptom_Check.Links.Symptoms'),
		}, {
			id: 'regions',
			label: this.angularFilterHelperService.translate('Symptom_Check.Links.Regions'),
		}, {
			id: 'interview',
			label: this.angularFilterHelperService.translate('Symptom_Check.Links.Interview'),
		}, {
			id: 'results',
			label: this.angularFilterHelperService.translate('Symptom_Check.Links.Results'),
		}];
	}
	
	setStep(index) {
		var steps: any = this.getValidatedSteps();
		var step: any = steps[index] || {};
		
		if (!step.isValid && !step.isInProgress) {
			return;
		}
		this.state.currentStep = step;
	}
	
	nextStep(skipStepCount?) {
		var ids: any = this.getStepIds();
		var currentIndex: any = this.state.currentStep ? ids.indexOf(this.state.currentStep.id) : -1;
		var stepsAdded: any = (skipStepCount ? (skipStepCount + 1) : 1);
		this.setStep(currentIndex + stepsAdded);
	}
	
	prevStep = (): any => {
		var ids: any = this.getStepIds();
		var currentIndex: any = this.state.currentStep ? ids.indexOf(this.state.currentStep.id) : -1;
		this.setStep(Math.max(0, currentIndex - 1));
	}
	
	getCurrentStepId() {
		return this.state.currentStep && this.state.currentStep.id;
	}
	
	getStepIds() {
		var steps: any = this.getSteps();
		return steps.map(function(step) { return step.id; });
	}
	
	validateStep(step) {
		if (!step) {
			console.error('No step specified in SymptomCheckService function validateStep');
			return;
		}
		
		var interview: any = this.getInterview();
		switch (step) {
			case 'introduction':
				{
					return interview.consents &&
						interview.consents.tos &&
						interview.consents.emergency &&
						interview.consents.sharing;
				}
			case 'patient':
				{
					return interview.selfTest === true ||
						(
							!interview.selfTest &&
							['male', 'female'].indexOf(interview.sex) !== -1 &&
							((interview.age >= 3 && interview.age <= 120) || (interview.age < 3 && interview.ageInMonths >= 0 && interview.ageInMonths <= 36))
						);
				}
			case 'factors':
				{
					return interview.evidence &&
						interview.evidence.length &&
						!interview.evidence.filter(function(evidence) { return !evidence.choice_id; }).length;
				}
			case 'symptoms':
				{
					return interview.evidence &&
						!!interview.evidence.filter(function(evidence) { return evidence.initial || evidence.source == 'initial'; }).length;
				}
			case 'regions':
				{
					return interview.sessionId && interview.localId && interview.diagnosis;
				}
			case 'interview':
				{
					return interview.diagnosis && interview.diagnosis.should_stop;
				}
			case 'results':
				{
					return true;
				}
			default:
				return false;
		}
	}
	
	getValidatedSteps() {
		var lastStepValid: any = true;
		var steps: any = this.getSteps();
		
		return steps.map((step) => {
			var currentStepValid = this.validateStep(step.id);
			step.isValid = lastStepValid && currentStepValid;
			step.isInProgress = lastStepValid !== step.isValid && !step.isValid;
			lastStepValid = step.isValid;
			return step;
		});
	}
	
	getInterview() {
		try {
			var storageInterview: any = window.localStorage.getItem(this.config.getSymptomCheckConfig().STORAGE_KEY);
			if (storageInterview) {
				var result = JSON.parse(storageInterview);
				if (!result.consents) {
					result['consents'] = {};
				}
				return result;
			} else {
				return this.initNewInterview();
			};
		} catch (e) {
			return this.initNewInterview();
		}
	}
	
	initNewInterview() {
		var result = {};
		result['consents'] = {};
		return result;
	}
	
	updateInterview(interview) {
		if (!interview) {
			console.error('No interview specified in SymptomCheckService function updateInterview');
			return;
		}
		window.localStorage.setItem(this.config.getSymptomCheckConfig().STORAGE_KEY, JSON.stringify(interview));
	}
	
	getGroupChoiceOptions() {
		return {
			present: this.angularFilterHelperService.translate('Common.Yes'),
			absent: this.angularFilterHelperService.translate('Common.No'),
			unknown: this.angularFilterHelperService.translate('Common.Dont_Know'),
		};
	}
	
	getInterviewResetTo(index) {
		var interview: any = this.getInterview();
		
		interview.evidence = interview.evidence || [];
		interview.evidence = interview.evidence.filter(function(evidence) { return evidence.addedAtStep <= index; });
		
		delete interview.sessionId;
		delete interview.localId;
		delete interview.stepId;
		delete interview.diagnosis;
		delete interview.currentSubStep;
		delete interview.triage;
		
		return interview;
	}
	
}